import React from 'react';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { create } from '~/actions/orderNew';
import Title from '~/components/Title';
import DatePicker from '~/components/DatePicker';
import CustomerPicker from '~/components/CustomerPicker';
import styleDialog from '~/style/dialog.scss';

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  submit() {
    create(this.props.dispatch, this.context.apiClient, this.state).then(() =>
      this.context.dialogClose(this.props.dialogId)
    ).then(() => this.props.data.onCreate && this.props.data.onCreate());
  }

  render() {
    return (
      <div
        className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')}
        onClick={() => this.context.dialogClose(this.props.dialogId)}
      >
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton
            className={styleDialog.closeButton}
            icon="close"
            onClick={() => this.context.dialogClose(this.props.dialogId)}
          />
          <div className={styleDialog.content}>
            <form
              onSubmit={e => {
                e.preventDefault();
                this.submit();
              }}
            >
              <Title style={{ paddingBottom: '10px' }}>New order</Title>
              <div>Reference</div>
              <input
                value={this.state.reference}
                onChange={e => this.setState({ reference: e.target.value })}
              />
              <DatePicker
                label="ETA"
                locale="us"
                sundayFirstDayOfWeek
                value={this.state.eta}
                onChange={eta => this.setState({ eta })}
                onDismiss={() => this.setState({ eta: null })}
              />
              <div>Customer:&nbsp;
              <CustomerPicker
                value={this.state.customerId || ''}
                onChange={(v) => this.setState({ customerId: v })}
              />
              </div>
              <div>Notes</div>
              <textarea
                value={this.state.notes}
                onChange={e => this.setState({ notes: e.target.value })}
                style={{ width: '100%', minHeight: '100px' }}
              />
              <Button type="submit" label="create" primary raised style={{ width: '100%' }} />
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/OrderNew/index.js